import { render, staticRenderFns } from "./courseLearningRatexbk.vue?vue&type=template&id=ee8a2428&scoped=true"
import script from "./courseLearningRatexbk.vue?vue&type=script&lang=js"
export * from "./courseLearningRatexbk.vue?vue&type=script&lang=js"
import style0 from "./courseLearningRatexbk.vue?vue&type=style&index=0&id=ee8a2428&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8a2428",
  null
  
)

export default component.exports